import store from "store2";

const STATE = "state";
const defaultState = {
  // 5JtUScZK2XEp3g9gh7F8bwtPTRAkASmNrrftmx4AxDKD5K4zDnr
  account: {
    name: "putcopayment",
    key: "",
  }
};

function reset() {
  store.set(STATE, defaultState);
}

function get() {
  // get state
  let loadState = store.get(STATE);

  // if none are there, load default settings..
  if (!loadState) {
    store.set(STATE, defaultState);
  }

  // return state.
  return store.get(STATE);
}

function set(key, val) {
  // get state
  let loadState = store.get(STATE);

  // update state with new key
  loadState[key] = val;

  // save state..
  return store.set(STATE, loadState);
}

export default { get, set, reset };
